import React from "react";
import { BackgroundPaths } from "./ui/background-paths";

const Hero: React.FC = () => {
  return (
    <BackgroundPaths
      title="Run Your Trucking Business Smarter"
      buttonText="Apply Now"
      buttonLink="https://www.jotform.com/build/252234291018147?iak=dae4eff51219b6094cb16302b76e055a-a139263544e2ec56"
    />
  );
};

export default Hero;
